import type { App } from 'vue';
import { authDirective } from './auth';
export function setupDirective(app: App) {
  authDirective(app);
}
